<template>
<div class="container">
  <template>
  <div class="addRoute">
    <div class="addRoute__header">
        <h1 class="medium-title">Edit Route</h1>
    </div>
    <div v-if="!isLoadingAll" class="addRoute__body">
      <!-- Left Content -->
      <div class="addRoute__body__left">
        <div class="addRoute__body__left__form">
        <!-- Route -->
          <div class="addRoute__body__left__form__container">
            <h1 class="subhead">Route</h1>
            <div class="addRoute__body__left__form__container__item">
              <adx-input :label="`Name`" :value.sync="model.routeNameInput" :validation="['NewNotEmpty','NewMinLength:3', 'NewMaxLength:50', 'Alphanumeric']"
              :class="[error.route_name && model.route_name == null ? 'warning' : '']" :ref="dataRef.routeNameInput" :error.sync="errors.routeNameInput"/>
            </div>
            <div class="addRoute__body__left__form__container__item">
              <adx-textarea :label="`Description`" :value.sync="model.descriptionRouteInput"  :validation="['NewNotEmpty','NewMinLength:3', 'NewMaxLength:256', 'Alphanumeric']"
              :class="[error.descriptionRouteInput  && model.descriptionRouteInput == null ? 'warning' : '']" :ref="dataRef.descriptionRouteInput" :error.sync="errors.descriptionRouteInput" />
              <div v-if="error.descriptionRouteInput  && model.descriptionRouteInput == null" class="error-message">This field is required! please enter route description</div>
            </div>
            <div class="addRoute__body__left__form__container__item">
              <adx-select-dropdown class="dropdown" :label="`Categories`" :options="categoriesOption" :value.sync="model.categoryDropdown" 
              :class="[error.categoryDropdown  && model.categoryDropdown == null ? 'warning' : '']" :ref="dataRef.categoryDropdown" :error.sync="errors.categoryDropdown" :validation="['NewNotEmpty']"
              @addNew="toogleCategoriesModal"
              :insertAddNew="`true`"
              />
            </div>
            <div class="addRoute__body__left__form__container__item">
              <adx-textarea :label="`Content restriction`" class="textarea"  :value.sync="model.restrictionDescriptionInput"  :validation="['NewMaxLength:256',  'Alphanumeric']"
              :class="[error.restrictionDescriptionInput && model.restrictionDescriptionInput == null ? 'warning' : '']" :ref="dataRef.restrictionDescriptionInput" :error.sync="errors.restrictionDescriptionInput"/>
              <div v-if="error.restrictionDescriptionInput  && model.restrictionDescriptionInput == null" class="error-message">This field is required! please enter a Content restriction</div>
            </div>
          </div>
          <!-- Map and Waypoint -->
          <div class="addRoute__body__left__form__container">
            <h1 class="subhead">Map and Waypoint</h1>
              <div class="addRoute__body__left__form__container__file">
              <div :class="[error.kmlFileData && kmlFileName == null ? 'upload-wrapper-warning' :'']">
                <div class="upload-wrapper">
                <!-- <div class="upload-wrapper-warning"> -->
                  <div class="top">
                    <div class="upload-button">
                      <input type="file" accept=".kml" @change="getFile"
                      ref="fileUpload" style="display: none;"  :validation="['NewNotEmpty']">
                      <button
                        type="button"
                        :class="['secondary', 'btn-small', 'btn-checkout-large', isSaving ? 'disabled' : '']"
                        @click="launchFilePicker">
                        Upload Route
                      </button>
                    </div>
                  </div>
                  <div class="bottom">
                    <span class="file_name">
                      <label class="label" v-if="!kmlFileName">Upload your .kml file</label>
                      <label class="label" v-else>{{kmlFileName}}</label>
                      <i v-if="kmlFileName" @click="cancelFile()" class="adx-ic_cancel"></i>
                    </span>
                    <div class="file_status" v-if="kmlLoading != null">
                      <span v-if="kmlLoading" class="is_loading"> Loading... </span>
                      <span v-if="!kmlLoading && kmlSuccess" class="is_success"> Uploaded </span>
                      <span v-if="!kmlLoading && !kmlSuccess" class="is_error"> Error </span>
                    </div>
                  </div>
                </div>
              </div>
                <div v-if="error.kmlFileData && kmlFileData == null" class="error-message">This field is required! please upload .kml file</div>
              </div>
            <div class="addRoute__body__left__form__container__route">
              <div v-for="(wayPoint, index) in model.wayPoints" :key="index" class="addRoute__body__left__form__container__route__detail">
                <div class="top size">
                  <div class="waypointWrapper">
                    <div class="waypoint">
                      <adx-select-dropdown :class="['dropdown', error.pointInterestDropdown && wayPoint.pointInterestDropdown == null ? 'warning' : '']" :label="`Waypoint`" :options="WaypointOptions" :value.sync="wayPoint.pointInterestDropdown" @selected="showModal($event,index,wayPoint)"
                      :validation="['NewNotEmpty']" :ref="dataRef.pointInterestDropdown" :error.sync="errors.pointInterestDropdown[index]"
                      @addNew="showModal($event,index)"
                      :insertAddNew="`true`"
                      />
                      <span v-if="error.pointInterestDropdown && wayPoint.pointInterestDropdown == null" class="error-message">This field is required! please enter waypoint type for your waypoint location</span>
                    </div>
                    <div class="location">
                      <adx-input :class="[ error.locationInterest && wayPoint.locationInput == null ? 'warning' :'']" :label="`Location Name`" :value.sync="wayPoint.locationInput"  :validation="['NewNotEmpty', 'NewMinLength:3', 'NewMaxLength:50', 'Alphanumeric']"
                      :ref="dataRef.locationInput" :error.sync="errors.locationInput[index]"/>
                      <span v-if="error.locationInterest && wayPoint.locationInput == null" class="error-message">This field is required! please enter waypoint location name</span>
                    </div>
                  </div>
                  <div class="icon-wrapper"><i @click="deleteWayPoint(model.wayPoints, index)" class="icon-deleted"></i></div>
                </div>
              </div>
              <div class="line-wrapper">
                <hr class="line">
              </div>
              <div class="button">
                <button @click="addWayPoint(model.wayPoints)" class="new">Add new</button>
              </div>
            </div>
          </div>
        <!-- Placement -->
         <div class="addRoute__body__left__form__placement">
            <h1 class="subhead">Placement</h1>
            <div class="addRoute__body__left__form__placement__items">
              <table>
                <thead class="none">
                  <tr>
                    <td class="header subhead">PLACEMENT</td>
                    <td class="header subhead center-title">INIT. QUANTITY</td>
                    <td class="header subhead center-title">ACTIVE</td>
                    <td class="header subhead center-title">PUBLIC</td>
                  </tr>
                </thead>
                <tbody v-if="!isLoadingAll && !isEmpty">
                  <tr v-for="(item, index) in items" :key="index" class="content">
                    <td class="placement subhead">{{item.placements}}</td>
                    <td class="quantity subhead">{{item.quantity}}</td>
                    <td class="check-icon subhead">
                      <span v-if="item.active" class="check"><img src="/img/adxicon/ic-add2.png" alt=""></span>
                      <span v-else class="none"> - </span>
                    </td>
                    <td class="check-icon subhead">
                      <span v-if="item.public" class="check"><img src="/img/adxicon/ic-add2.png" alt=""></span>
                      <span v-else class="none"> - </span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="emptyState" v-if="items.length < 1">
                  <adx-empty-selection/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Right Content -->
      <div class="addRoute__body__right">
        <div class="addRoute__body__right__status__container">
          <h1 class="subhead">Ownership</h1>
          <div class="dropdown">
            <adx-single-search-dropdown :label="`Owner email`" :optionsParam="ownerOption" :value.sync="model.ownerDropdown" :size="'size'"
            :class="[error.ownerDropdown && model.ownerDropdown == null ? 'warning' : '']" :validation="['NewNotEmpty']"
            :ref="dataRef.ownerDropdown" :error.sync="errors.ownerDropdown"/>
            <div v-if="error.ownerDropdown && model.ownerDropdown == null" class="error-message">This field is required! please enter Owner email</div>
          </div>
          <!-- <div>
            <adx-single-search-dropdown :label="`Group ( Optional )`" :optionsParam="groupOption" :value.sync="model.group" :size="'size'"
            :class="[error.group && model.group == null ? 'warning' : '']"/>
          <div v-if="error.group && model.group == null" class="error-message">This field is required! please enter Group name</div>
          </div> -->
        </div>
        <div class="button">
          <button class="btn-large primary" @click="save">
            Save
            <adx-loading-2 v-if="saveLoading"/>
          </button>
        </div>
      </div>
    </div>
  <!-- Modal -->
    <adx-modal v-if="isShowModalCategories" :title="`Add New Categories`" @modal-close="toogleCategoriesModal" type='small'>
      <div class="addRoute__modal__category" slot="content">
        <adx-input class="input" :label="`Categories Name`"
                   :value.sync="model.newCategories"
                   :validation="['NewNotEmpty','NewMinLength:3', 'NewMaxLength:50', 'Alphanumeric']"
                   ref="refCategories"
                   :error.sync="errorCategories"
                   @keypress.enter.native="createCategory($event, 'key')"/>
        <div class="buttons">
          <button class="btn-regular secondary" @click="toogleCategoriesModal">Cancel</button>
          <button class="btn-large primary save" @click="createCategory($event, 'mouse')">
            Save
            <adx-loading-2 v-if="modalLoading"/>
          </button>
        </div>
      </div>
    </adx-modal>
    <div v-for="(wayPoint, index) in model.wayPoints" :key="index">
      <adx-modal v-if="isShowModalWayPoint[index]" :title="`Add Way Point`" @modal-close="showModal($event,index)" type='small'>
        <div class="addRoute__modal__way-point"  slot="content">
            <adx-input class="input" :label="`Waypoint Name`"
                       :value.sync="model.newPointInterest"
                       :validation="['NewNotEmpty','NewMinLength:3', 'NewMaxLength:100', 'Alphanumeric']"
                       ref="refPointInterest"
                       :error.sync="errorPointInterest"
                       @keypress.enter.native="createPointInterest($event,index, 'key')"/>
          <div class="buttons">
            <button class="btn-regular secondary" @click="showModal($event,index)">Cancel</button>
            <button class="btn-large primary save" @click="createPointInterest($event,index,'mouse')">
              Save
              <adx-loading-2 v-if="modalLoading"/>
            </button>
          </div>  
        </div>
      </adx-modal>
    </div>
    <adx-modal v-if="isShowModalOwner && model.ownerDropdown === 'addnew'" :title="`Add New Owner`" @modal-close="toogleModal()" type='small'>
      <div class="addRoute__modal__owner"  slot="content">
          <adx-input class="input" :label="`Email User`" :value.sync="model.newOwner" :validation="['NewNotEmpty','NewMinLength:3', 'NewMaxLength:50', 'Email']"/>
        <div class="buttons">
          <button class="btn-regular secondary" @click="toogleModal(0)">Cancel</button>
          <button class="btn-large primary" @click="save">Save</button>
        </div>
      </div>
    </adx-modal>
    <adx-modal v-if="isShowModalGroup && model.group === 'addnew'" :title="`Add New Group`" @modal-close="toogleModal()" type='small'>
      <div class="addRoute__modal__group"  slot="content" >
      <adx-input class="modalInput" :label="`Group Name`" :value.sync="model.newGroup" :validation="['NewNotEmpty','NewMinLength:3', 'NewMaxLength:50']"/>
      <div class="buttons">
        <button class="btn-regular secondary" @click="toogleModal(0)">Cancel</button>
        <button class="btn-large primary" @click="save">Save</button>
        </div>
      </div>
    </adx-modal>
  </div>
  </template>
  <template v-if="isLoadingAll">
    <div class="container__loadingWrapper">		
    <slot name="loading" />		
    <adx-loading/>	
    </div>	
  </template>
</div>
</template>	

<script>
  import Loading from '@/components/Loading/Primary'
  import LoadingWhite from '@/components/Loading/Secondary-white';
  import Input from '@/components/Form/Input'
  import SelectDropdown from '@/components/Form/SelectDropdown'
  import Dropdown from '@/components/Form/SelectDropdown'
  import ListDropdown from '@/components/Dropdown/ListDropdown'
  import Checkbox from '@/components/Form/Checkbox'
  import TextArea from '@/components/Form/TextArea'
  import InputTag from '@/components/Form/InputTag'
  import SingleSearchDropdown from '@/components/Dropdown/SingleSearchDropdown'
  import Modal from '@/components/Modal'
  import EmptySelection from '@/components/NotFound/Selection'

  import * as validationLib from '@/lib/validation/'
  import triggerValidation from '@/lib/triggerValidation'
  import {mapGetters} from 'vuex';

  const {
  helpers,
  validate
} = validationLib;


export default {
  name: 'adx-add-route',
  components: {
    'adx-input': Input,
    'adx-select-dropdown': SelectDropdown,
    'adx-dropdown': Dropdown,
    'adx-dropdown-list': ListDropdown,
    'adx-checkbox': Checkbox,
    'adx-textarea': TextArea,
    'adx-input-tag': InputTag,
    'adx-single-search-dropdown': SingleSearchDropdown,
    'adx-modal': Modal,
    'adx-loading': Loading,
    'adx-loading-2': LoadingWhite,
    'adx-empty-selection': EmptySelection,
  },
  props: {
    
  },
  data() {
    return {
      countCategory: 0,
      countInterest: 0,
      errorCategories: null,
      errorPointInterest: null,
      eventCategoryDone: false,
      eventEmailDone: false,
      eventInterestDone: false,
      eventRouteDone: false,
      isEmpty: false,
      isLoadingAll: false,
      isSaving: true,
      isShowModalCategories: false,
      isShowModalWayPoint: [],
      isShowModalOwner: false,
      isShowModalGroup: false,
      kmlFile: null,
      kmlFileName: null,
      kmlFileData: null,
      kmlFileId: null,
      kmlLoading: null,
      kmlSuccess:false,
      modalLoading:false,
      route: null,
      saveLoading: false,
      size : 'small',
      userInputted: true,

      categories: [],
      errorLocation:[],
      items: [],
      ownerOption:[],
      categoriesOption:[],
      WaypointOptions: [],
      model: {
        routeNameInput: null,
        descriptionRouteInput: null,
        categoryDropdown: null,
        restrictionDescriptionInput: null,
        user: null,
        group: null,
        wayPoints: [
          {   
            pointInterestDropdown: null,
            locationInput: null,
          }
        ],
        newCategories: null,
        newPointInterest: null,
        newOwner: null,
        newGroup: null
      },
      groupOption: [
        {
          'id': 0,
          'label': 'Add New',
          'value': 'addnew'
        },
        {
          'id': 1,
          'label': 'ABC Group',
          'value': 'abcgroup'
        },
        {
          'id': 2,
          'label': 'Amazon Group',
          'value': 'amazongroup'
        }
      ],
      dataRef:{
        routeNameInput: "routeNameInput",
        descriptionRouteInput: "descriptionRouteInput",
        categoryDropdown: "categoryDropdown",
        restrictionDescriptionInput: "restrictionDescriptionInput",
        locationInput:"locationInput",
        pointInterestDropdown:"pointInterestDropdown",
        ownerDropdown:"ownerDropdown"
      },
      errors:{
        routeNameInput: null,
        descriptionRouteInput: null,
        categoryDropdown: null,
        restrictionDescriptionInput: null,
        locationInput:[
          null
        ],
        pointInterestDropdown:[
          null
        ],
        ownerDropdown:null
      },
      error: {
        routeNameInput: null,
        descriptionRouteInput: null,
        categoryDropdown: null,
        restrictionDescriptionInput: null,
        kmlFileData: null,
        pointInterestDropdown: null,
        locationInterest: null,
        ownerDropdown: null,
        group: null
      },
    }
  },
  computed: {
    ...mapGetters({
      user: 'account',
      token: 'token'
    }),
    isLoading: function(){
      return (this.$apollo.loading && !this.modalLoading)||false
    },
  },
  apollo: {
    // route: {
    //   query: require('@/graphql/bus/query/routeInstance.gql'),
    //   loadingKey: 'loading',
    //   errorPolicy: 'all',
    //   // fetchPolicy: 'no-cache',
    //   variables(){
    //     return {
    //       id: this.id.toString()
    //     }
    //   },
    //   result(data){
    //     let params = {
    //       search: this.searchBoxValue,
    //       sort: this.selectedSortValue == "last_added" ? "" : this.selectedSortValue,
    //       page: this.selectedPage
    //     }
    //     const { route } = data.data
    //     if (route) {
    //       this.mapData(route)
    //     }

    //   }
    // },
  },
  watch: {
    'model.categoryDropdown':function() {
      this.toogleModal()
    },
    'model.ownerDropdown':function() {
      this.toogleModal()
    },
    'model.group':function() {
      this.toogleModal()
    },
    'model.routeNameInput': function () {
      this.capitalizeRouteName()
    },
    'model.descriptionRouteInput': function () {
      this.capitalizeDescRoute()
    },
    'model.restrictionDescriptionInput': function () {
      this.capitalizeRestrictDesc()
    },
    'model.newCategories': function (after, before) {
      if (after) this.capitalizeNewCategories()
    },
    'model.newPointInterest': function (after, before) {
      if (after) this.capitalizeNewPointInterest()
    },
    'model.newOwner': function () {
      this.capitalizeNewOwner()
    },
    'model.newGroup': function () {
      this.capitalizeNewGroup()
    }
  },
  beforeCreate() {
    const { id } = this.$route.params;
    this.id = id
  },
  created() {
    this.$on('event-done', async () => {
      if (this.eventCategoryDone && this.eventInterestDone && this.eventEmailDone && this.eventRouteDone) {
        // Map this data
        await this.mapData(this.route);
        this.isLoadingAll = false
      } 
    })
  },
  beforeMount() {

  },
  async mounted() {
    localStorage.setItem('apollo-token', this.token);
    this.isLoadingAll = true;
    this.getCategoryOptions();
    this.getInterestOptions();
    this.getEmailOptions();
    this.getRoute()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async getCategoryOptions(){
      const result = await this.$apollo.query({
        query: require('@/graphql/bus/query/categories.gql'),
        loadingKey: 'loading',
        errorPolicy: 'all',
        fetchPolicy: 'network-only',
      });

      if (result.data){
        if (result.errors){
          this.handleError(result.errors, 'category')
        } else {
          const { categories } = await result.data;
          let res = [];

          await categories.map(x => {
            res.push(
              {'id': x.id, 'label': x.title, 'value': x.id}
            )
          });
          this.categoriesOption = await res;
          this.eventCategoryDone = true;
          this.$emit('event-done')
        }
      }
    },
    async getInterestOptions(){
      const result = await this.$apollo.query({
        query: require('@/graphql/bus/query/interest.gql'),
        loadingKey: 'loading',
        errorPolicy: 'all',
        fetchPolicy: 'network-only',
      });

      if (result.data){
        if (result.errors){
          this.handleError(result.errors, 'interest')
        } else {
          const { interests } = await result.data;
          let res = [];

          await interests.map(x => {
            res.push(
              {'id': x.id, 'label': x.title, 'value': x.id}
            )
          });
          this.WaypointOptions = await res;
          this.eventInterestDone = true;
          this.$emit('event-done')
        }
      }
    },
    async getEmailOptions(){
      const result = await this.$apollo.query({
        query: require('@/graphql/bus/userEmails.gql'),
        loadingKey: 'loading',
        errorPolicy: 'all',
        fetchPolicy: 'network-only',
      });
      if (result.data){
        const { userEmails } = result.data;
        let res = [];
        if (userEmails) {
          await userEmails.map(x => {
            res.push(
              {'id':parseInt(x.id), 'label':x.email, 'value':x.email}
            )
          })
        }       
        this.ownerOption = await res;
        this.eventEmailDone = true;
        this.$emit('event-done')
      }
    },
    async getRoute(){
      const result = await this.$apollo.query({
        query: require('@/graphql/bus/query/routeInstance.gql'),
        variables:{
          id: this.id.toString()
        },
        loadingKey: 'loading',
        errorPolicy: 'all',
        fetchPolicy: 'network-only',
      });
      if (result.data){
        this.eventRouteDone = true;
        
        // let params = {
        //   search: this.searchBoxValue,
        //   sort: this.selectedSortValue === "last_added" ? "" : this.selectedSortValue,
        //   page: this.selectedPage
        // };
        const { route } = await result.data;
        if (route) {
          this.route = await route;
          this.$emit('event-done')
        }
      } else {
        this.raiseError('Route not found!')
        this.$router.push({name: 'buschannel'})
        this.isLoadingAll = false
      }
    },
    async createCategory(event, button) {
      if(button === "mouse"){
        this.newCategory(this.model.newCategories)
      } else{
        this.newCategory(event.target.value)
      }
    },
    async newCategory(item){
      let element = this.$refs['refCategories'].$el.firstElementChild
      element.focus()
      element.blur()

      let valid = !this.errorCategories
      if (valid) {
        this.modalLoading = true;
        const result = await this.$apollo.mutate({
          mutation: require('@/graphql/bus/mutation/categoryAdd.gql'),
          variables: {
            input: {
              title: item
            },
          },
        });

        this.isShowModalCategories = false;
        const { id } = result.data.createCategory;
        this.countCategory = 0
        await this.getCategoryOptions();
        this.modalLoading = false;
        this.model.categoryDropdown = id.toString()
      }
    },
    async createPointInterest(event,index, button) {
      if(button === "mouse"){
        this.newPointInterest(this.model.newPointInterest, index)
      } else {
        this.newPointInterest(event.target.value, index)
      }
    },
    async newPointInterest(item,index){
      let element = this.$refs['refPointInterest'][0].$el.firstElementChild
      element.focus()
      element.blur()

      let valid = !this.errorPointInterest
      if (valid) {
        this.modalLoading = true;
        const result = await this.$apollo.mutate({
          mutation: require('@/graphql/bus/mutation/interestAdd.gql'),
          variables: {
            input: {
              title: item
            },
          },
        });

        this.isShowModalWayPoint[index] = false;
        const { id } = result.data.createInterest;

        this.countInterest = 0
        await this.getInterestOptions();
        this.modalLoading = false;
        this.model.wayPoints[index].pointInterestDropdown = id.toString()
      }
    },
    async save(){
      this.saveLoading = true;
      let routerVal = this.ownerOption;
      const body = 
          {
            title: this.model.routeNameInput,
            description: this.model.descriptionRouteInput,
            categories: this.model.categoryDropdown,
            forbiddenAds: this.model.restrictionDescriptionInput,
            fileRoute: this.kmlFileName,
            routeDetail: this.model.wayPoints,
            owner: this.getId(routerVal, this.model.ownerDropdown),
            ownerGroup: this.model.group,
            daily_trip: 1,
            seats: 1,
            traffic: 1
          };

      let validation1 = triggerValidation(this.model, this.dataRef, this.$refs, this.errors);
      if (validation1){
        let validation2 = true;
        for (let i = 0; i < this.model.wayPoints.length; i++){
          let temp = this.model.wayPoints[i].pointInterestDropdown;
          this.model.wayPoints[i].pointInterestDropdown ='';
          if (this.errors.pointInterestDropdown[i] !== false){
            validation2 = false
          } else {
            this.model.wayPoints[i].pointInterestDropdown = temp
          }
        }

        if (validation2) {
          //let validationFile = true;
          if(this.kmlFileName == null){
            this.error.kmlFileData = true;
            this.$refs.fileUpload.focus()
          } else if (this.model.ownerDropdown == null){
            this.error.ownerDropdown = true;
            window.scrollTo(0,0);
          } else{
            let route_detail = [];
            this.model.wayPoints.map(wp => {
              route_detail.push({
                location: wp.locationInput,
                interest: {id : parseInt(wp.pointInterestDropdown)}
              })
            });
            window.scrollTo(0,0);

            const ownerId= body.owner

            const result = await this.$apollo.mutate({
              mutation: require('@/graphql/bus/mutation/routeEdit.gql'),
              variables: {
                id: this.id,
                route: {
                  title: this.model.routeNameInput,
                  description: this.model.descriptionRouteInput,
                  forbiddenAds: this.model.restrictionDescriptionInput,
                  category: {id : parseInt(body.categories)},
                  routeDetails: route_detail,
                  fileRoute: this.kmlFileId,
                  owner: ownerId|| null
                }
              }
            }
            );
            this.saveLoading = true;
            if (result.data) {
              this.$notify({
                group: 'saved',
                title: 'Success',
                text: `Data successfully saved!`,
                type: 'success'
              });
              this.$router.push({name: 'buschannel'})
            } else {
              this.$notify({
                group: 'saved',
                title: 'Error',
                text: `Data failed to save`,
                type: 'danger'
              });
            }
          }
        }
      }
      this.saveLoading = false
    },
    async mapData(obj){
      let kmlName = null;
      if (obj.fileRoute.content_url){
        let kmlArray = obj.fileRoute.content_url.split('/');
        kmlName = kmlArray.pop()
      }
      this.model.routeNameInput = obj.title;
      this.model.descriptionRouteInput = obj.description;
      this.model.categoryDropdown = obj.category.id;
      this.model.restrictionDescriptionInput = obj.forbiddenAds;
      this.kmlFileName = kmlName;
      this.model.ownerDropdown = obj.owner? obj.owner.email : null;
      this.kmlFileId = parseInt(obj.fileRoute.id);
      this.model.wayPoints = obj.routeDetails.map(wp =>{
        let data = {};
          data.pointInterestDropdown = wp.interest.id.toString();
          data.locationInput = wp.location;
          return data
      });
      for (let x of obj.generics) {
        this.items.push(
          {
            placements : x.title,
            quantity: x.quantity,
            active: x.isActive,
            public: x.isPublic,
          },
        )
      }
    },
    showNotify(){
      this.$notify({
        group: 'saved',
        title: 'Error',
        text: `Something went wrong. Please refresh the page!`,
        type: 'danger'
      });
    },
    async handleError(errors, param){
      const parsedError = parseErrorGql(errors);
      if (parsedError.hasError){
        if (parsedError.code === 403 || parsedError.code === 404 || parsedError.code === 204){
          let code = parsedError.code;
          if (parsedError.code === 204) code = 404;
          this.$router.push({ name: `${code}` })
        }else if (parsedError.code === 502){
          switch(param){
            case 'category':
              this.countCategory++;
              if (this.countCategory<3) {
                await this.getCategoryOptions()
              } else {
                this.showNotify();
                this.eventCategoryDone = true
                this.$emit('event-done')
              }
              break;
            case 'interest':
              this.countInterest++;
              if (this.countInterest<3) {
                await this.getInterestOptions()
              } else {
                this.showNotify();
                this.eventInterestDone = true
                this.$emit('event-done')
              }
              break;
          }
        }else {
          this.$router.push({ name: `500` })
        }
      }
    },
    async saveKMLFile(){
      this.kmlLoading = true;
      const result = await this.$apollo.mutate({
        mutation: require('@/graphql/bus/mutation/routeFileAdd.gql'),
        errorPolicy: 'all',
        variables: {
          content : {file :this.kmlFileData}
        },
      });
      this.kmlLoading = false;
      if (!result.errors && !result.error) {
        this.kmlSuccess = true;
        this.kmlFileId = parseInt(result.data.uploadFile.id)
      } else {
        this.kmlSuccess = false
      }
    },
    inputValidation() {
      let data = { isValid: true, errorMessage: null };
      let isValid = true;
      if(this.model.routeNameInput == null) {
        data.isValid = false;
        data.errorMessage = "This field is required! please enter Route name.";
        isValid = false;
        this.error.routeNameInput = true
      } else if (this.model.descriptionRouteInput == null){
        data.isValid = false;
        data.errorMessage = "This field is required! please enter Route description.";
        isValid = false;
        this.error.descriptionRouteInput = true
      } else if (this.model.categoryDropdown == null){
        data.isValid = false;
        data.errorMessage = "This field is required! please Select Bus Categories.";
        isValid = false;
        this.error.categoryDropdown = true
      } else if (this.model.restrictionDescriptionInput == null){
        data.isValid = false;
        data.errorMessage = "This field is required! please enter a Content restriction.";
        isValid = false;
        this.error.restrictionDescriptionInput = true
      } else if (this.kmlFileData == null){
        data.isValid = false;
        data.errorMessage = "This field is required! please upload .kml file";
        isValid = false;
        this.error.kmlFileData = true
      } else if (this.model.wayPoints.length > 0){
        for (let i =0; i < this.model.wayPoints.length; i++){
          if (!this.model.wayPoints[i].pointInterestDropdown){
            data.isValid = false;
            data.errorMessage = "This field is required! please enter waypoint type for your waypoint location";
            this.error.pointInterestDropdown = true
          }else if (!this.model.wayPoints[i].locationInput){
            data.isValid = false;
            data.errorMessage = "This field is required! please enter waypoint location name";
            this.error.locationInterest = true
          }
        }
      } else if (this.model.ownerDropdown == null){
        data.isValid = false;
        data.errorMessage = "This field is required! please enter Owner email.";
        isValid = false;
        this.error.ownerDropdown = true
      } else if (this.model.group == null){
        data.isValid = false;
        data.errorMessage = "This field is required! please enter Group name.";
        isValid = false;
        this.error.group = true
      }
      return data
    },
    raiseError(errorMessage) {
      this.$notify({
        group: 'saved',
        title: 'Error',
        text: errorMessage,
        type: 'danger'
      });
    },
    addWayPoint(wayPoint) {
      wayPoint.push(
        {
          locationInput: null,
          pointInterestDropdown: null,
        }
      );
      this.isShowModalWayPoint.push(false);
      this.errors.locationInput.push(
      null);
      this.errors.pointInterestDropdown.push(
      null)
    },
    deleteWayPoint(wayPoint, index) {
      if (wayPoint.length > 1) {
        wayPoint.splice(index, 1);
        this.errors.locationInput.splice(index,1);
        this.errors.pointInterestDropdown.splice(index,1);
        this.isShowModalWayPoint.splice(index,1)
      } else {
        this.$notify({
          group: 'saved',
          title: 'Delete Error',
          text: 'Oops data can not be deleted!',
          type: 'danger'
        });
      }
    },
    cancelFile(){
      this.kmlFileName= '';
      this.kmlLoading=null
    },
    async getFile(event) {
      let input = event.target;
      if (input.files && input.files[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.kmlFile = e.target.result
        };
        reader.readAsDataURL(input.files[0]);
        this.kmlFileName = input.files[0].name;
        this.kmlFileData = input.files[0];
        await this.saveKMLFile()
      }
    },
    launchFilePicker(){
      this.$refs.fileUpload.click();
    },
    getId(options, value){
      let id = null;
      for(let it=0;it<options.length;it++){
        if(options[it].value === value){
          id = options[it].id
        }
      }
      return id
    },
    showModal(event,index){
      let wayPointId = event && event.item? event.item.id : null;
      if(wayPointId === 0 || !wayPointId){
        let val = !this.isShowModalWayPoint[index];
        // this.isShowModalWayPoint = !this.isShowModalWayPoint
        this.$set(this.isShowModalWayPoint, index, val)
      } else{
        this.isShowModalWayPoint[index] =  false
      }
      this.model.newPointInterest = null
      this.errorPointInterest = null
    },
    toogleCategoriesModal(){
      this.isShowModalCategories = !this.isShowModalCategories
      this.model.newCategories = null
      this.errorCategories = null
    },
    toogleModal(event, idx) {      
      if (this.model.categoryDropdown === 'addnew'){
        this.isShowModalCategories = !this.isShowModalCategories
      }if (this.model.ownerDropdown === 'addnew'){
        this.isShowModalOwner = !this.isShowModalOwner
      }if (this.model.group === 'addnew'){
        this.isShowModalGroup = !this.isShowModalGroup
      }
    },
    capitalizeRouteName(){
      this.model.routeNameInput = this.model.routeNameInput.charAt(0).toUpperCase() + this.model.routeNameInput.slice(1)
    },
    capitalizeDescRoute(){
      this.model.descriptionRouteInput = this.model.descriptionRouteInput.charAt(0).toUpperCase() + this.model.descriptionRouteInput.slice(1)
    },
    capitalizeRestrictDesc(){
      this.model.restrictionDescriptionInput = this.model.restrictionDescriptionInput.charAt(0).toUpperCase() + this.model.restrictionDescriptionInput.slice(1)
    },
    capitalizeNewCategories(){
      this.model.newCategories = this.model.newCategories.charAt(0).toUpperCase() + this.model.newCategories.slice(1)
    },
    capitalizeNewPointInterest(){
      this.model.newPointInterest = this.model.newPointInterest.charAt(0).toUpperCase() + this.model.newPointInterest.slice(1)
    },
    capitalizeNewOwner(){
      this.model.newOwner = this.model.newOwner.charAt(0).toUpperCase() + this.model.newOwner.slice(1)
    },
    capitalizeNewGroup(){
      this.model.newGroup = this.model.newGroup.charAt(0).toUpperCase() + this.model.newGroup.slice(1)
    },
    capitalizewayPointLocation(){
      this.model.wayPoint.locationInput = this.model.wayPoint.locationInput.charAt(0).toUpperCase() + this.model.wayPoint.locationInput.slice(1)
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang='scss'>
@import '~@/styles/variables';
@import '~@/styles/mixins';

.addRoute {
  &__body {
    &__left {
      &__form {
        &__size {
          .selectDropdown {
            input {
              padding-top: 0;
            }

            .popup{
              &__input{
                max-width: 100%;
                margin-left: 48px;
              }
            }
          }
        }
      }
    }
  }

  .waypointWrapper {
    display: flex;
  }

  input {
    min-height: 62px;
  }

  .selectDropdown {
    .popup{
      max-height:300px;
      overflow-y:auto;
    }
    .select {
      input {
        min-height: 62px;
      }
    }
  }

  .btn-regular {
    min-width: 32px;
    height: 45px;

    &.teal {
      background-color: $white;
      border: solid 1px $pale-grey;
      color: unset;
    }
  }

  .title.large-font {
    font-size: 24px;
  }
}
</style>
